import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "z9"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  role: "button",
  class: "fl mt5 fs11 ddgrey",
  style: {}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"18px","height":"18px"},
  class: "rad6 fl mr5 orangeBg force mt2"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 ml8 fs11 ddgrey",
  style: {}
}, "強制可能枠に変更", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"18px","height":"18px"},
  class: "rad6 fl mr5 orangeBg force mt2"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 ml8 fs11 ddgrey",
  style: {}
}, "強制をはずす", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"18px","height":"18px"},
  class: "rad6 fl mr5 blackbrownBg mt2"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 ml8 fs11 ddgrey",
  style: {}
}, "不可日時に変更", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"18px","height":"18px"},
  class: "rad6 fl mr5 orangeBg mt2"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 ml8 fs11 ddgrey",
  style: {}
}, "可能日時に変更", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 ml8 fs11 ddgrey",
  style: {}
}, "イベントを削除", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHelp = _resolveComponent("IconHelp")!

  return (_ctx.ev)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        ([`optional_add`, `optional_remove`, `event`].includes(_ctx.ev.type) && !_ctx.Util.isRoomSettingsPreview())
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addEvent(`cal`))),
              class: "fs12 pointer fw600 pad10",
              style: {"line-height":"40px","width":"160px"}
            }, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/create_event.png`),
                width: 18,
                height: "18",
                class: "fl mt1 mr5"
              }, null, 8, _hoisted_2),
              _createElementVNode("p", _hoisted_3, "イベントを" + _toDisplayString(_ctx.ev.type == `event` ? `変更` : `作成`), 1),
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        ([`optional_add`].includes(_ctx.ev.type) && !_ctx.ev.is_force && _ctx.cm.astag && _ctx.cm.astag.can_connect_calendar)
          ? (_openBlock(), _createElementBlock("li", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addEvent(`availableForce`))),
              class: "fs12 pointer fw600 pad10",
              style: {"line-height":"40px","width":"160px"}
            }, [
              _hoisted_5,
              _hoisted_6,
              _createVNode(_component_IconHelp, {
                style: {"margin-right":"0","margin-top":"2px","margin-left":"3px"},
                color: `grey`,
                width: 18,
                class: "fl",
                tooltipText: `waaqLink上で日程が確定されるまで日程候補として表示されます。`
              }),
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        ([`optional_add`].includes(_ctx.ev.type) && _ctx.ev.is_force)
          ? (_openBlock(), _createElementBlock("li", {
              key: 2,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addEvent(`available`))),
              class: "fs12 pointer fw600 pad10",
              style: {"line-height":"40px","width":"160px"}
            }, _hoisted_11))
          : _createCommentVNode("", true),
        ([`optional_add`].includes(_ctx.ev.type))
          ? (_openBlock(), _createElementBlock("li", {
              key: 3,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addEvent(`notAvailable`))),
              class: "fs12 pointer fw600 pad10",
              style: {"line-height":"40px","width":"160px"}
            }, _hoisted_15))
          : _createCommentVNode("", true),
        ([`optional_remove`].includes(_ctx.ev.type))
          ? (_openBlock(), _createElementBlock("li", {
              key: 4,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addEvent(`available`))),
              class: "fs12 pointer fw600 pad10",
              style: {"line-height":"40px","width":"160px"}
            }, _hoisted_19))
          : _createCommentVNode("", true),
        ([`event`].includes(_ctx.ev.type))
          ? (_openBlock(), _createElementBlock("li", {
              key: 5,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addEvent(`delete`))),
              class: "fs12 pointer fw600 pad10",
              style: {"line-height":"40px","width":"160px"}
            }, _hoisted_22))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}